// @flow
import React from 'react';
import cx from 'classnames';
import { Link } from 'gatsby';
import svgMap from './svgs';
import s from './s.module.scss';

export default ({ tag, className }: { tag: string, className: string }) => (
  <h2 className={s.tag}>
    <span class="emoji">
      {svgMap.hasOwnProperty(tag) &&
        (typeof svgMap[tag] === 'string' ? (
          <img src={svgMap[tag]} />
        ) : (
          svgMap[tag]
        ))}
    </span>
    {tag}
  </h2>
);
